"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESIDENT_MESSAGES = {
    getResidentPccLoginCredential: {
        message: 'Login cannot be empty',
    },
    getResidentPccPasswordCredential: {
        message: 'Password cannot be empty',
    },
};
